import { createAsyncThunk, createSlice, createSelector } from '@reduxjs/toolkit'
import axios from 'axios'
import _ from 'lodash'
import {
  createCreditCardUrl,
} from 'urls'
import { getAxiosDefaultConfig } from '../../modules/utils'
import { sendGtmPixel, pickPrimaryStoreAccount } from 'tagManager'

export const initialState = {
  newCreditCard: {
    status: 'idle',
    data: null,
    error: null,
  }
}

export const addCreditCard = createAsyncThunk('planSettings/addCreditCard', async (token, { getState, rejectWithValue }) => {
  try {
    const { data: res } = await axios.post(
      createCreditCardUrl,
      { token },
      getAxiosDefaultConfig()
    )
    sendGtmPixel({
      ...res,
      storeAccount: pickPrimaryStoreAccount(getState().root.accounts),
    }, 'cc_added')
    return res
  }
  catch(error) {
    console.error(error)
    const errorMessage = _.get(error, ['response', 'data', 'error'], 'Internal Error')
    return rejectWithValue(errorMessage)
  }
})

export const planSlice = createSlice({
  name: 'planSettings', // temporary name until we can remove the old settings state altogether
  initialState,
  reducers: {
  },
  extraReducers(builder) {
    builder
      /**
       *
       * add credit card
       *
       */
      .addCase(addCreditCard.pending, (state, action) => {
        state.newCreditCard.status = 'loading'
      })
      .addCase(addCreditCard.fulfilled, (state, action) => {
        console.log(action)
        state.newCreditCard.status = 'succeeded'
        state.newCreditCard.data = action.payload
        state.newCreditCard.error = null
      })
      .addCase(addCreditCard.rejected, (state, action) => {
        state.newCreditCard.status = 'failed'
        state.newCreditCard.error = (action.payload as string) || action.error.message
      })
  },
})

export const {} = planSlice.actions

export const selectNewCreditCard = (state) => state.planSettings.newCreditCard.data
export const selectNewCreditCardStatus = (state) => state.planSettings.newCreditCard.status
export const selectNewCreditCardError = (state) => state.planSettings.newCreditCard.error

// Select from the legacy redux state
export const selectCurrentCreditCardsSubscription = createSelector(
  [(state) => state.plan.creditCards, (state) => state.plan.subscription],
  (creditCards, subscription) => ({ creditCards, subscription })
)
export const selectIsStripeBilling = (state) => state.plan.billingChannel === 'stripe'

// Memoized selector for add-ons
const EMPTY_ARRAY = []
export const selectPlanAddOns = (state) => state.plan?.addOns || EMPTY_ARRAY
export const selectTrafficAddOnEnabled = createSelector(
  [selectPlanAddOns],
  (addOns) => addOns.find(a => a.plans?.[0]?.product === 'Traffic')
)
export const selectAddOnUpgradeDismissed = (state, product) => !!state.plan.addOnUpgradeDismissed?.[product]

export default planSlice.reducer